import React from 'react';

const DaikinRebate = (props) => {
	let result = props.result;
	// Adjust for NB
	if (result === 'ducted-new' || result === 'ducted-rep') {
		result = 'ducted';
	}
	let daikin = props.content.daikin;

	const content = (result) ? daikin[result] : '';

	return (
		<div className={props.classes}>
			<div className="app__responsive-wrap app__emco_col_6">
				<div className="app__results-savings">
					<p>{props.content.daikinTitle}</p>
					<p className="app__results-dollars">
						<span className="app__results_range-title--super">{props.content.daikinSuper}</span>
						<span className="app__results_range-title">{content.range}</span>
					</p>
				</div>
			</div>
			<div className="app__responsive-wrap app__emco_col_6">
				<div className="app__results-thankyou">
					<p>{content.copy}</p>
					{ content.sourceUrl &&
						<p><a className="app__results-source" target="_blank" href={content.sourceUrl}>{content.source}</a></p>
					}
				</div>
			</div>
		</div>
	);
};

export default DaikinRebate;



// WEBPACK FOOTER //
// ./src/components/DaikinRebate.js